import { ComplianceStatus, PlanogramComplianceConfig } from '../types';

export const DEFAULT_PLANOGRAM_COMPLIANCE_CONFIG: PlanogramComplianceConfig = {
  // Toggle settings
  useTemplateBox: false,
  movesByShelf: false,
  // Advanced settings
  minSimilarityThreshold: 0.87,
  minStackingSimilarityThreshold: 1,
  maxDifferenceThreshold: 0.04,
  minSsmConfidence: 0.8,
  minIntersectionArea: 0.2,
  oosOverrideArea: 0.9,
  oosOverrideThreshold: 0.6,
  bottomThresholdCartonsFromPolygons: 0.2,
  usePtTemplateBoxes: true,
  compliantStatus: [ComplianceStatus.COMPLIANT, ComplianceStatus.OUT],
  osaStatus: [ComplianceStatus.COMPLIANT, ComplianceStatus.NON_COMPLIANT],
  compliantStatusToKeep: [],
  useBleedovers: false,
  useSmallBleedovers: true,
  bleedoverIgnoreModOrder: false,
  bleedoverMirrorPosition: false,
  createTasks: true,
  obstructionThreshold: null,
  priceTagGlareEnabled: false,
  priceTagGlareOverridePct: null,
  removeOutsideCameraActions: false,
  correctGroupMoves: true,
  groupMoveBridgeSize: 1,
  groupMoveSize: 2,
  useItemNumber: true,
  faceoverResetThreshold: 0.5,
  applyForgivenessThreshold: true,
  forgivenessThreshold: 1,
};
